"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _OrientedCoordinateArray = _interopRequireDefault(require("../noding/OrientedCoordinateArray"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _TreeMap = _interopRequireDefault(require("../../../../java/util/TreeMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EdgeList =
/*#__PURE__*/
function () {
  function EdgeList() {
    _classCallCheck(this, EdgeList);

    EdgeList.constructor_.apply(this, arguments);
  }

  _createClass(EdgeList, [{
    key: "print",
    value: function print(out) {
      out.print("MULTILINESTRING ( ");

      for (var j = 0; j < this._edges.size(); j++) {
        var e = this._edges.get(j);

        if (j > 0) out.print(",");
        out.print("(");
        var pts = e.getCoordinates();

        for (var i = 0; i < pts.length; i++) {
          if (i > 0) out.print(",");
          out.print(pts[i].x + " " + pts[i].y);
        }

        out.println(")");
      }

      out.print(")  ");
    }
  }, {
    key: "addAll",
    value: function addAll(edgeColl) {
      for (var i = edgeColl.iterator(); i.hasNext();) {
        this.add(i.next());
      }
    }
  }, {
    key: "findEdgeIndex",
    value: function findEdgeIndex(e) {
      for (var i = 0; i < this._edges.size(); i++) {
        if (this._edges.get(i).equals(e)) return i;
      }

      return -1;
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._edges.iterator();
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "get",
    value: function get(i) {
      return this._edges.get(i);
    }
  }, {
    key: "findEqualEdge",
    value: function findEqualEdge(e) {
      var oca = new _OrientedCoordinateArray.default(e.getCoordinates());

      var matchEdge = this._ocaMap.get(oca);

      return matchEdge;
    }
  }, {
    key: "add",
    value: function add(e) {
      this._edges.add(e);

      var oca = new _OrientedCoordinateArray.default(e.getCoordinates());

      this._ocaMap.put(oca, e);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EdgeList;
}();

exports.default = EdgeList;

EdgeList.constructor_ = function () {
  this._edges = new _ArrayList.default();
  this._ocaMap = new _TreeMap.default();
};